const BUILDING_STACK_BREAKPOINT = 940;

export const getBuildingSidePlacement = (viewportWidth) => (
  viewportWidth <= BUILDING_STACK_BREAKPOINT ? 'content' : 'side'
);

export const getBuildingSidePadding = (viewportWidth, titleHeight, titleMarginBottom) => {
  if (getBuildingSidePlacement(viewportWidth) === 'content') {
    return 0;
  }

  return Math.max(0, titleHeight) + Math.max(0, titleMarginBottom);
};
